import React from "react";
import { useDraggable } from "@dnd-kit/core";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { blockRegistry } from "../registry/blocks";

const BRAND = "#069d6e";

const GROUPS = [
  {
    title: "Content",
    types: ["heading", "text", "button", "buttonRow", "link", "image"],
  },
  {
    title: "Layout",
    types: ["header", "banner", "split", "columns", "divider", "spacer"],
  },
  { title: "Navigation & social", types: ["menu", "social"] },
  { title: "Footers", types: ["footer", "footerDark"] },
  { title: "Advanced", types: ["html"] },
];

function PaletteItem({ type, onAdd }) {
  const def = blockRegistry[type];
  const Icon = def.icon;
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `palette:${type}`,
    data: { source: "palette", blockType: type },
  });

  return (
    <button
      ref={setNodeRef}
      type="button"
      {...listeners}
      {...attributes}
      onClick={() => onAdd(type)}
      className="group relative flex items-center gap-2 rounded-lg border border-gray-200 bg-white py-2.5 px-3 text-left text-gray-700 transition hover:border-[#069d6e] hover:shadow-sm"
      style={{ opacity: isDragging ? 0.4 : 1, cursor: "grab", touchAction: "none" }}
      title={`Add ${def.label} (click or drag)`}
    >
      <span
        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md"
        style={{ backgroundColor: `${BRAND}14` }}
      >
        <Icon style={{ color: BRAND }} fontSize="small" />
      </span>
      <span className="text-[13px] font-medium">{def.label}</span>
      <DragIndicatorIcon
        fontSize="small"
        className="ml-auto text-gray-300 opacity-0 transition group-hover:opacity-100"
      />
    </button>
  );
}

export default function Palette({ onAdd }) {
  return (
    <div className="h-full overflow-y-auto px-3 py-4">
      <div className="mb-1 px-1 text-sm font-semibold text-gray-800">
        Add blocks
      </div>
      <div className="mb-4 px-1 text-[11px] text-gray-400">
        Click to append, or drag onto the canvas
      </div>
      <div className="flex flex-col gap-5">
        {GROUPS.map((group) => (
          <div key={group.title}>
            <div className="mb-2 px-1 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
              {group.title}
            </div>
            <div className="flex flex-col gap-2">
              {group.types.map((type) => (
                <PaletteItem key={type} type={type} onAdd={onAdd} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
